<template>
  <div>
    <div id="descriptionSection" class="white">
      <div v-html="description"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopDescriptionSection",
  props: {
    description: String
  }
};
</script>

<style scoped>
/* shared */
#descriptionSection {
  padding: 20px;
  margin-top: 2px;
}

</style>